import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../../lib/utils';
import { tertiaryText } from '../../../../../styling/stylingHelper';
import { BlockSource } from '../../../../../services/admin/cloudAgentTypes';

/**
 * Subtle provenance footnote rendered under every numeric block:
 * "Based on <computation> · <period>". v1 affordance only — full drill-down is GENUI-4.
 */
export const BlockSourceNote: React.FC<{ source?: BlockSource }> = ({ source }) => {
  const { t } = useTranslation();
  if (!source) return null;
  // `source.period` is a PeriodSpec OBJECT — it must never reach a template. Only the server's
  // pre-rendered `periodLabel` is printable; without it the note drops the period part.
  return (
    <p className={cn(tertiaryText, 'text-[11px] mt-1')}>
      {source.periodLabel
        ? t('cloudAgent.source', { computation: source.computation, period: source.periodLabel })
        : t('cloudAgent.sourceNoPeriod', { computation: source.computation })}
    </p>
  );
};
